import { render, staticRenderFns } from "./comment_more.vue?vue&type=template&id=66fc4ab3&scoped=true&"
import script from "./comment_more.vue?vue&type=script&lang=js&"
export * from "./comment_more.vue?vue&type=script&lang=js&"
import style0 from "./comment_more.vue?vue&type=style&index=0&id=66fc4ab3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fc4ab3",
  null
  
)

export default component.exports